<template>
<div class="locale-changer">
  <div v-for="(country, i) in getCountries" :key="i" @click="changeLan(country.language)">
    <country-flag :class="findActive(country.language)" :country="country.flag" />
  </div>
</div>
</template>

<script>
import CountryFlag from 'vue-country-flag';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    CountryFlag
  },
  name: 'locale-changer',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('Language', [
      'getCountries',
      'getCurrentLanguage'
    ])
  },
  methods: {
    ...mapActions('Language', [
      'changeLanguage',
    ]),
    changeLan(language) {
      this.changeLanguage(language);
      this.$i18n.locale = language;
      localStorage.setItem('TAKT_language', language);
    },
    findActive(language) {
      if (language === this.getCurrentLanguage) {
        return 'active'
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="css" scoped>
  .locale-changer {
    display: flex;
    gap: 3px;
  }
  .active {
    border: solid 2px;
    border-radius: 10px;
    border-color: silver;
  }
</style>
